import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MetaTags } from 'react-meta-tags';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/loginpage.css';
import Logo from '../images/logo_transparent.png';

const ActivationMail = () => {
  const [nomailError, setNoEmailError] = useState(false);
  const [alreadyActiveError, setAlreadyActiveError] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [clientError, setClientError] = useState('');
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  let item = '';
  const navigate = useNavigate();

  const itemStr = localStorage.getItem('isLogin');
  try {
    item = itemStr ? JSON.parse(itemStr) : null;
  } catch (_) {
    item = null;
  }
  const now = new Date();

  function onFinish(data) {
    setNoEmailError(false);
    setAlreadyActiveError(false);
    setSuccessMsg(false);

    try {
      const json = JSON.stringify({ email: data.email });

      const headers = {
        'Content-Type': 'application/json',
      };

      axios
        .post(
          'https://epolylearning.com/Services/polyquiz.svc/ResendMail',
          json,
          { headers }
        )
        .then((response) => {
          const userData = response.data;
          console.log(response.data);

          if (userData.ResendMailResult.FirstName === 'No Such Email.') {
            setNoEmailError(true);
          } else if (
            userData.ResendMailResult.Email !== undefined &&
            userData.ResendMailResult.IsActivated === true
          ) {
            setAlreadyActiveError(true);
          } else if (
            userData.ResendMailResult.Email !== undefined &&
            userData.ResendMailResult.IsActivated === false
          ) {
            setSuccessMsg(true);
          }
        })
        .finally(() => setSubmitting(false));
    } catch (error) {
      console.log(error);
      setSubmitting(false);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setClientError('');
    setNoEmailError(false);
    setAlreadyActiveError(false);
    setSuccessMsg(false);

    const trimmed = email.trim();
    if (!trimmed) {
      setClientError('Please input your E-mail!');
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmed)) {
      setClientError('The input is not valid E-mail!');
      return;
    }

    setSubmitting(true);
    onFinish({ email: trimmed });
  };

  useEffect(() => {
    if (itemStr && item && item.expiry > now.getTime()) {
      navigate('/');
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <MetaTags>
        <title>Resend Account Activation Mail - PolyQuiz</title>
        <meta id="meta-description" name="description" />
      </MetaTags>

      <div className="am-page">
        <div className="am-card">
          <div className="am-header">
            <img src={Logo} alt="PolyQuizz logo" className="am-logo" />
            <div className="am-header-text">
              <span className="am-pill">Account Activation</span>
              <h1 className="am-title">Resend Activation Mail</h1>
              <p className="am-subtitle">
                Enter the email you used during sign up and we&apos;ll send you a
                fresh activation link.
              </p>
            </div>
          </div>

          <form className="am-form" onSubmit={handleSubmit} noValidate>
            <label className="am-field">
              <span className="am-label">Email address</span>
              <div className="am-input-wrap">
                <input
                  type="email"
                  className="am-input"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </label>

            {clientError && (
              <div className="am-message am-error" role="alert">
                {clientError}
              </div>
            )}

            <button
              type="submit"
              className="am-submit-btn"
              disabled={submitting}
            >
              {submitting ? 'Sending…' : 'Send Activation Mail'}
            </button>
          </form>

          {/* Server-side response messages */}
          {alreadyActiveError && (
            <div className="am-message am-info" role="alert">
              Account associated with this email is already verified. Please{' '}
              <Link to="/login" className="am-link">
                login
              </Link>{' '}
              to continue.
            </div>
          )}

          {nomailError && (
            <div className="am-message am-error" role="alert">
              There is no account associated with this email. You can{' '}
              <Link to="/signup" className="am-link">
                sign up
              </Link>{' '}
              to get started.
            </div>
          )}

          {successMsg && (
            <div className="am-message am-success" role="status">
              Mail sent successfully. Please check your inbox for the activation
              link.
            </div>
          )}

          <div className="am-footer-row">
            <span className="am-footer-text">
              Don&apos;t have an account?{' '}
              <Link to="/signup" className="am-link-strong">
                Sign up
              </Link>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivationMail;
